import styled from "styled-components";

export const ActivityFormAdminPreviewContainerStyled = styled.div`
  padding: ${({ isCustomer }) =>
    isCustomer ? "20px 20px 40px 20px" : "20px 0"};
  .breadcrumb_layout {
    margin-bottom: 30px;
  }
  .activity_form_admin_preview_container {
    margin: auto;
    max-width: ${({ theme }) => theme.ETC.ACTIVITY_DETAIL_WIDTH};
    .preview_notice_layout {
      margin-bottom: 20px;
      .close_preview_row {
        display: flex;
        justify-content: flex-end;
        padding-bottom: 8px;
        padding-top: 8px;
        border-bottom: 1px solid ${({ theme }) => theme.COLORS.GRAY_6};
        .close_preview_btn {
          display: flex;
          align-items: center;
          column-gap: 8px;
          cursor: pointer;
          color: ${({ theme }) => theme.COLORS.PURPLE_1};
          font-size: ${({ theme }) => theme.FONT.SIZE.S14};
          font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_SEMIBOLD};
        }
      }
      .preview_notice_box {
        margin-top: 16px;
        padding: 12px 16px;
        border-radius: 6px;
        text-align: center;
        background: ${({ theme }) => theme.COLORS.ORANGE_2};
        color: ${({ theme }) => theme.COLORS.PURPLE_1};
        font-size: ${({ theme }) => theme.FONT.SIZE.S14};
        font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_SEMIBOLD};
      }
    }
    .header_question_layout {
      margin-bottom: 28px;
      border-radius: 10px;
      border: 1px solid ${({ theme }) => theme.COLORS.PURPLE_1};
      overflow: hidden;
      .title {
        padding: 12px 12px;
        background: ${({ theme }) => theme.COLORS.PURPLE_1};
        color: ${({ theme }) => theme.COLORS.WHITE_1};
        font-size: ${({ theme }) => theme.FONT.SIZE.S15};
        font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_SEMIBOLD};
      }
      .desc {
        padding: 14px 12px;
        color: ${({ theme }) => theme.COLORS.BLACK_1};
        font-size: ${({ theme }) => theme.FONT.SIZE.S13};
        font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_LIGHT};
      }
    }
    .quiz_container_layout {
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
    }
  }

  @media (max-width: ${({ theme }) => theme.SCREENS.SURFACE_DUO}) {
    padding: ${({ isCustomer }) =>
      isCustomer ? "10px 20px 40px 20px" : "0px"};
    .breadcrumb_layout {
      display: none;
    }
    .activity_form_admin_preview_container {
      .preview_notice_layout {
        margin-bottom: 16px;
        .preview_notice_box {
          font-size: ${({ theme }) => theme.FONT.SIZE.S13};
        }
      }
    }
  }
`;
